import AditionalOption from 'components/summary/AditionalOption/styled';

export default AditionalOption;
